import { BehaviorSubject } from 'rxjs';
import { Document } from "shared/models/site/document";
import { toISOLocalDate, formatTime } from "shared/models/mapping/mapping";
import { DocumentReviewPeriodEnum } from "shared/enums/document-review-period-enum"

export type DocumentAddEditState = {
    document: Document,
    originalDocument: Document
}

const emptyDocument: Document = {
    effectiveFromDate: toISOLocalDate(new Date()),
    effectiveFromTime: formatTime(new Date()),
    publishDate: toISOLocalDate(new Date()),
    publishTime: formatTime(new Date()),
    documentModule: 2,
    relatedDocuments: [],
    subTypeLabel: null,
    reviewPeriod: DocumentReviewPeriodEnum.None,
    requiresAcknowledgementAndNotify: true
}
const createInitialState = (): DocumentAddEditState => ({ document: Object.assign({}, emptyDocument), originalDocument: {} })

const documentAddEditStateSubject = new BehaviorSubject<DocumentAddEditState>(createInitialState());

export const documentAddEditState = {
    subscribe: (setState: any) => documentAddEditStateSubject.subscribe(setState),
    setState: (fn: (state: DocumentAddEditState) => void) => {
        var newState = Object.assign({}, documentAddEditStateSubject.getValue());
        fn(newState);
        documentAddEditStateSubject.next(newState);
    },
    reset: () => {
        documentAddEditStateSubject.next(createInitialState());
    }
}